<template>
  <div class="taoliifycont between">
    <div class="left">
      <taolimenulist class="menu" :menulist="tlmenuL" ref="menulist" />
      <ifilawtj class="mt30" />
      <ifizxfg class="mt30" />
    </div>
    <div class="righ">
      <ifisea />
      <ifirmfg class="mt30" />
      <zxlaw class="ifizxzx mt30" />
    </div>
  </div>
</template>

<script>
import taolimenulist from "views/tiaoli/components/taolimenulist";
import ifilawtj from "../components/ifilawtj";
import ifizxfg from "../components/ifizxfg";
import ifisea from "../components/ifisea";
import ifirmfg from "../components/ifirmfg";
import zxlaw from "../components/ifizxlaw";
export default {
  components: {
    taolimenulist,
    ifilawtj,
    ifizxfg,
    ifisea,
    ifirmfg,
    zxlaw,
  },
  data() {
    return {
      tlmenuL: [],
      crtid: 0,
    };
  },
  beforeMount() {
    this.getmenulist();
    this.crtid = this.$route.query.id;
  },

  methods: {
    getmenulist() {
      this.$http.jpcol
        .gettiaoliify()
        .then((res) => {
          this.tlmenuL = res.data;
          this.crtid = this.tlmenuL.findIndex((item) => item.id == this.crtid);
          this.$nextTick(() => {
            this.$refs.menulist.cptag(this.crtid);
          });
          console.log("获取法律条例列表");
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.taoliifycont {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  align-items: flex-start;
  .left {
    width: 856px;
  }
  .righ {
    width: 314px;
    .ifizxzx {
      width: 100%;
      height: 416px;
    }
  }
}
</style>